import { z } from 'zod';
import { ConversationMessage } from '../client';
import { makeEvent } from './EventBase';

export const ConversationMessageUpdated = makeEvent(
    'Conversation\\ConversationMessageUpdated',
    z.object({
        data: ConversationMessage,
    }),
);

export type ConversationMessageUpdated = (typeof ConversationMessageUpdated)['schema']['_output'];
